import React, { useMemo } from "react";

import { Document, Page, Text, View, StyleSheet, Image, Font } from "@react-pdf/renderer";



Font.register({

    family: 'Poppins',

    fonts: [

        {

            src: '/fonts/Poppins-Regular.ttf',

            fontWeight: 'normal',

        },

        {

            src: '/fonts/Poppins-SemiBold.ttf',

            fontWeight: 600,

        },

        {

            src: '/fonts/Poppins-Bold.ttf',

            fontWeight: 'bold',

        },

    ],

});



const styles = StyleSheet.create({

    page: {

        padding: 20,

    },

    col: {

        display: "flex",

        flexDirection: "row",

        border: "1px solid black",

    }

});



const OnlineStudentReport = ({ data }) => {

    const studentdata = Array.isArray(data) ? data : [];

const estimateRowHeight = (row) => {
    const discussion = row.discussion || "";
    const email = row.Email || "";

    const baseHeight = 80;

    const discussionLines = Math.ceil(discussion.length / 100); // adjust per font size
    const emailLines = Math.ceil(email.length / 35);

    const extraHeight = (discussionLines + emailLines) * 20;

    return baseHeight + extraHeight;
};

const chunkByEstimatedHeight = (data, pageHeight = 720) => {
    const pages = [];
    let currentPage = [];
    let currentHeight = 0;

    for (const row of data) {
        const rowHeight = estimateRowHeight(row);

        // If row is too big to fit on current page, push to new page
        if (rowHeight > pageHeight) {
            if (currentPage.length) {
                pages.push(currentPage);
                currentPage = [];
                currentHeight = 0;
            }
            pages.push([row]); // row gets full page
            continue;
        }

        // If current row overflows page height, start new page
        if (currentHeight + rowHeight > pageHeight) {
            pages.push(currentPage);
            currentPage = [row];
            currentHeight = rowHeight;
        } else {
            currentPage.push(row);
            currentHeight += rowHeight;
        }
    }

    if (currentPage.length > 0) {
        pages.push(currentPage);
    }

    return pages;
};


// In your component
const pages = useMemo(() => chunkByEstimatedHeight(studentdata), [studentdata]);



    function formatDate(dateInput) {
        const date = new Date(dateInput);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`; 
    }



    return (

        <Document>

            {pages.map((pageData, pageIndex) => (

                <Page key={pageIndex} size="A4" style={styles.page}>

                    <View style={[styles.header, { textAlign: "center", fontSize: "10px" }]}>

                        <Text style={{ fontFamily: "Poppins", fontWeight: "bold" }}>

                            Online Admission for course : {pageData[0].Course_Name}

                        </Text>

                    </View>



                    <View style={[styles.col]}>

                        <View style={{ borderRight: "1px solid black", width: "10%" }}>

                            <Text style={{ textAlign: "center", fontSize: 9, fontFamily: "Poppins", fontWeight: "bold" }}>Id</Text>

                        </View>

                        <View style={{ borderRight: "1px solid black", width: "15%" }}>

                            <Text style={{ textAlign: "center", fontSize: 9, fontFamily: "Poppins", fontWeight: "bold" }}>Student Name</Text>

                        </View>

                        <View style={{ borderRight: "1px solid black", width: "20%" }}>

                            <Text style={{ textAlign: "center", fontSize: 9, fontFamily: "Poppins", fontWeight: "bold" }}>E-Mail</Text>

                        </View>

                        <View style={{ borderRight: "1px solid black", width: "15%" }}>

                            <Text style={{ textAlign: "center", fontSize: 9, fontFamily: "Poppins", fontWeight: "bold" }}>Mobile</Text>

                        </View>

                        <View style={{ borderRight: "1px solid black", width: "10%" }}>

                            <Text style={{ textAlign: "center", fontSize: 9, fontFamily: "Poppins", fontWeight: "bold" }}>Accept / Deny</Text>

                        </View>

                        <View style={{ borderRight: "1px solid black", width: "10%" }}>

                            <Text style={{ textAlign: "center", fontSize: 9, fontFamily: "Poppins", fontWeight: "bold" }}>Date</Text>

                        </View>

                        <View style={{ width: "20%" }}>

                            <Text style={{ textAlign: "center", fontSize: 9, fontFamily: "Poppins", fontWeight: "bold" }}>Discussion</Text>

                        </View>

                    </View>



                    {pageData.map((item, i) => (

                        <View key={i} style={[styles.col]}>

                            <View style={{ borderRight: "1px solid black", width: "10%" }}>

                                <Text style={{ textAlign: "center", fontSize: 9, fontFamily: "Poppins", fontWeight: "normal" }}>{item.Student_Id}</Text>

                            </View>

                            <View style={{ borderRight: "1px solid black", width: "15%" }}>

                                <Text style={{ textAlign: "center", fontSize: 9, fontFamily: "Poppins", fontWeight: "normal" }}>{item.Student_Name}</Text>

                            </View>

                            <View style={{ borderRight: "1px solid black", width: "20%", padding: 2, flexWrap: "wrap" }}>

                                <Text style={{

                                    fontSize: 9,

                                    fontFamily: "Poppins",

                                    fontWeight: "normal",

                                    textAlign: "center",

                                    wordBreak: 'break-word',

                                    flexWrap: 'wrap'

                                }}>

                                    {item.Email}

                                </Text>

                            </View>

                            <View style={{ borderRight: "1px solid black", width: "15%" }}>

                                <Text style={{ textAlign: "center", fontSize: 9, fontFamily: "Poppins", fontWeight: "normal" }}>{item.Present_Mobile}</Text>

                            </View>

                            <View style={{ borderRight: "1px solid black", width: "10%" }}>

                                <Text style={{ textAlign: "center", fontSize: 9, fontFamily: "Poppins", fontWeight: "normal" }}>{item.Status}</Text>

                            </View>

                            <View style={{ borderRight: "1px solid black", width: "10%" }}>

                                <Text style={{ textAlign: "center", fontSize: 9, fontFamily: "Poppins", fontWeight: "normal" }}>{formatDate(item.Status_date)}</Text>

                            </View>

                            <View style={{ width: "20%", padding: 2, flexWrap: "wrap", }}>

                                <Text style={{

                                    fontSize: 9,

                                    fontFamily: "Poppins",

                                    fontWeight: "normal",

                                    textAlign: "center",

                                    wordBreak: 'break-word',



                                }}>

                                    {item.discussion}

                                </Text>

                            </View>

                        </View>

                    ))}

                </Page>

            ))}

        </Document>

    );

}



export default OnlineStudentReport;